import {
  MERCHANT_PRODUCT_LIST_REQUEST,
  MERCHANT_PRODUCT_LIST_SUCCESS,
  MERCHANT_PRODUCT_LIST_FAIL,
  MERCHANT_PRODUCT_LIST_RESET,
  MERCHANT_PRODUCT_CREATE_REQUEST,
  MERCHANT_PRODUCT_CREATE_SUCCESS,
  MERCHANT_PRODUCT_CREATE_FAIL,
  MERCHANT_PRODUCT_CREATE_RESET,
  MERCHANT_PRODUCT_DELETE_REQUEST,
  MERCHANT_PRODUCT_DELETE_SUCCESS,
  MERCHANT_PRODUCT_DELETE_FAIL,
  MERCHANT_PRODUCT_DETAILS_REQUEST,
  MERCHANT_PRODUCT_DETAILS_SUCCESS,
  MERCHANT_PRODUCT_DETAILS_FAIL,
  MERCHANT_PRODUCT_DETAILS_RESET,
  MERCHANT_PRODUCT_STOCK_CHANGE_REQUEST,
  MERCHANT_PRODUCT_STOCK_CHANGE_SUCCESS,
  MERCHANT_PRODUCT_STOCK_CHANGE_FAIL,
  MERCHANT_PRODUCT_BULK_APPLY_REQUEST,
  MERCHANT_PRODUCT_BULK_APPLY_SUCCESS,
  MERCHANT_PRODUCT_BULK_APPLY_FAIL,
  MERCHANT_PRODUCT_BULK_APPLY_RESET,
  SIZES_CREATE_REQUEST,
  SIZES_CREATE_SUCCESS,
  SIZES_CREATE_FAIL,
  SIZES_CREATE_RESET,
  STOCK_CHECK_REQUEST,
  STOCK_CHECK_SUCCESS,
  STOCK_CHECK_FAIL,
  MERCHANT_PRODUCT_UPDATE_REQUEST,
  MERCHANT_PRODUCT_UPDATE_SUCCESS,
  MERCHANT_PRODUCT_UPDATE_FAIL,
  MERCHANT_PRODUCT_UPDATE_RESET,
  ADMIN_UNAPPROVED_LIST_REQUEST,
  ADMIN_UNAPPROVED_LIST_SUCCESS,
  ADMIN_UNAPPROVED_LIST_FAIL,
  ADMIN_APPROVE_PRODUCT_REQUEST,
  ADMIN_APPROVE_PRODUCT_SUCCESS,
  ADMIN_APPROVE_PRODUCT_FAIL,
  SEARCH_PRODUCT_REQUEST,
  SEARCH_PRODUCT_SUCCESS,
  SEARCH_PRODUCT_FAIL,
  SEARCH_PRODUCT_RESET,
  MERCHANT_PRODUCT_VALIDATE_REQUEST,
  MERCHANT_PRODUCT_VALIDATE_SUCCESS,
  MERCHANT_PRODUCT_VALIDATE_FAIL,
  ADMIN_CUSTOM_PRODUCTSEXPORT_FAIL,
  ADMIN_CUSTOM_PRODUCTSEXPORT_REQUEST,
  ADMIN_CUSTOM_PRODUCTSEXPORT_RESET,
  ADMIN_CUSTOM_PRODUCTSEXPORT_SUCCESS,
  PRODUCT_CUSTOMER_REQUEST,
  PRODUCT_CUSTOMER_SUCCESS,
  PRODUCT_CUSTOMER_FAIL,
} from "./productTypes";

export const productListReducer = (state = { products: [] }, action) => {
  switch (action.type) {
    case MERCHANT_PRODUCT_LIST_REQUEST:
      return { ...state, loading: true };
    case MERCHANT_PRODUCT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        products: action.payload.products,
        total: action.payload.totalProducts,
        category_filters: action.payload.filters.category,
        brands_filters: action.payload.filters.brandSlug,
        prices_filters: action.payload.filters.price,
        tags_filters: action.payload.filters.productTagname?.filter((aa) => aa._id !== null),
      };
    case MERCHANT_PRODUCT_LIST_FAIL:
      return { loading: false, error: action.payload };

    case MERCHANT_PRODUCT_LIST_RESET:
      return { ...state, products: [], total: 0 };

    case ADMIN_UNAPPROVED_LIST_REQUEST:
      return { ...state, loading: true };
    case ADMIN_UNAPPROVED_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        products: action.payload.products,
        total: action.payload.totalProducts,
      };
    case ADMIN_UNAPPROVED_LIST_FAIL:
      return { loading: false, error: action.payload };

    case PRODUCT_CUSTOMER_REQUEST:
      return { ...state, loading: true };

    case PRODUCT_CUSTOMER_SUCCESS:
      return { ...state, loading: false, customers: action.payload };

    case PRODUCT_CUSTOMER_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
export const productDetailsReducer = (state = { product: {} }, action) => {
  switch (action.type) {
    case MERCHANT_PRODUCT_DETAILS_REQUEST:
      return { ...state, loading: true };
    case MERCHANT_PRODUCT_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        product: action.payload,
      };
    case MERCHANT_PRODUCT_DETAILS_FAIL:
      return { loading: false, error: action.payload };

    case STOCK_CHECK_REQUEST:
      return { ...state, loading: true };
    case STOCK_CHECK_SUCCESS:
      return {
        ...state,
        loading: false,
        stocks: action.payload,
      };
    case STOCK_CHECK_FAIL:
      return { loading: false, error: action.payload };

    case MERCHANT_PRODUCT_DETAILS_RESET:
      return { ...state, product: {} };
    default:
      return state;
  }
};
export const productStockReducer = (state = {}, action) => {
  switch (action.type) {
    case MERCHANT_PRODUCT_STOCK_CHANGE_REQUEST:
      return { ...state, loading: true };
    case MERCHANT_PRODUCT_STOCK_CHANGE_SUCCESS:
      return {
        ...state,
        loading: false,
        messsage: action.payload.message,
      };
    case MERCHANT_PRODUCT_STOCK_CHANGE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
export const bulkApplyReducer = (state = {}, action) => {
  switch (action.type) {
    case MERCHANT_PRODUCT_BULK_APPLY_REQUEST:
      return { ...state, loading: true };
    case MERCHANT_PRODUCT_BULK_APPLY_SUCCESS:
      return {
        ...state,
        loading: false,
        messsage: action.payload.message,
        success: true,
      };
    case MERCHANT_PRODUCT_BULK_APPLY_FAIL:
      return { loading: false, error: action.payload };
    case MERCHANT_PRODUCT_BULK_APPLY_RESET:
      return { loading: false, success: false };
    default:
      return state;
  }
};
export const productCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case MERCHANT_PRODUCT_CREATE_REQUEST:
      return { ...state, loading: true };
    case MERCHANT_PRODUCT_CREATE_SUCCESS:
      return { loading: false, success: true, product: action.payload };
    case MERCHANT_PRODUCT_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case MERCHANT_PRODUCT_CREATE_RESET:
      return { product: {} };
    default:
      return state;
  }
};
export const sizeCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case SIZES_CREATE_REQUEST:
      return { ...state, loading: true, success: false };
    case SIZES_CREATE_SUCCESS:
      return { ...state, loading: false, success: true };
    case SIZES_CREATE_FAIL:
      return { ...state, loading: false, error: action.payload };
    case SIZES_CREATE_RESET:
      return { ...state, loading: false, success: false };
    default:
      return state;
  }
};

export const productUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case MERCHANT_PRODUCT_UPDATE_REQUEST:
      return { ...state, loading: true };
    case MERCHANT_PRODUCT_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        message: action.payload,
      };
    case MERCHANT_PRODUCT_UPDATE_FAIL:
      return { ...state, loading: false, error: action.payload };
    case MERCHANT_PRODUCT_UPDATE_RESET:
      return { product: {} };
    default:
      return state;
  }
};
export const productDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case MERCHANT_PRODUCT_DELETE_REQUEST:
      return { loading: true };
    case MERCHANT_PRODUCT_DELETE_SUCCESS:
      return { loading: false, success: true };
    case MERCHANT_PRODUCT_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
export const productApproveReducer = (state = {}, action) => {
  switch (action.type) {
    case ADMIN_APPROVE_PRODUCT_REQUEST:
      return { ...state, loading: true };
    case ADMIN_APPROVE_PRODUCT_SUCCESS:
      return { ...state, loading: false, success: action.payload._id };
    case ADMIN_APPROVE_PRODUCT_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
export const productSearchReducer = (state = {}, action) => {
  switch (action.type) {
    case SEARCH_PRODUCT_REQUEST:
      return { ...state, loading: true };
    case SEARCH_PRODUCT_SUCCESS:
      return { ...state, loading: false, search: action.payload.products };
    case SEARCH_PRODUCT_FAIL:
      return { ...state, loading: false, error: action.payload };
    case SEARCH_PRODUCT_RESET:
      return { ...state, loading: false, search: [] };
    default:
      return state;
  }
};
export const productValidateReducer = (state = { validation: "" }, action) => {
  switch (action.type) {
    case MERCHANT_PRODUCT_VALIDATE_REQUEST:
      return { ...state, loading: true };
    case MERCHANT_PRODUCT_VALIDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        validation: action.payload,
      };
    case MERCHANT_PRODUCT_VALIDATE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const customProductExport = (state = {}, action) => {
  switch (action.type) {
    case ADMIN_CUSTOM_PRODUCTSEXPORT_REQUEST:
      return { ...state, loading: true };
    case ADMIN_CUSTOM_PRODUCTSEXPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };
    case ADMIN_CUSTOM_PRODUCTSEXPORT_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
